<template>
  <v-row>
    <v-col cols="12">
      <v-alert type="info" dense>
        {{ item.infoText || 'Bitte wähle aus, an welchen vorgegebenen Terminen du Zeit hast.' }}
      </v-alert>

      <div
          v-for="(ev, idx) in item.events"
          :key="idx"
          class="mb-2 pa-3"
          style="border:1px solid rgba(0,0,0,0.1); border-radius:8px;"
      >
        <v-checkbox
            :label="formatEvent(ev)"
            :input-value="selectedIndices.includes(idx)"
            @click="toggleEvent(idx)"
            dense
            color="info"
            hide-details
        />
      </div>

      <div
          v-if="item.required && selectedIndices.length === 0"
          class="error--text caption mt-2"
      >
        Bitte wähle mindestens einen Termin aus.
      </div>
      <v-btn depressed block v-if="step > 1" @click="$emit('update:step', step - 1)" >
        Zurück
      </v-btn>

      <v-btn
          block
          class="my-4"
          color="info"
          @click="goNext"
          :disabled="item.required && selectedIndices.length === 0"
      >
        Weiter
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
import moment from 'moment';
import {LeanDocument} from 'mongoose';
import {
  SurveyItemType,
} from '@/enums/survey-manager/SurveyItemType.enum';
import {
  SurveyItemResponseType,
} from '@/enums/survey-manager/SurveyItemResponseType.enum';
import {
  UserSurveyDocument,
  EventSelection,
  EventSelectionItem,
} from '@/documentTypes/survey-manager/UserSurvey.document';
import {EventSelectionSurveyDataResponseItem} from "@/classes/dto/survey-manager/response/GetSurveyData.response.dto";

moment.locale('de');

export default Vue.extend({
  name: 'EventSelectionSurveyInput',
  props: {
    item: {
      type: Object as () => EventSelection & {
        type: SurveyItemType.EVENT_SELECTION;
        responseType:
            | SurveyItemResponseType.HANDOUT_AVAILABILITIES
            | SurveyItemResponseType.TEXT_ONLY;
      },
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    survey: {
      type: Object as () => LeanDocument<UserSurveyDocument>,
      required: true,
    },
    additionalData: {
      type: Object as () => EventSelectionSurveyDataResponseItem,
      required: true,
    },
  },
  data: () => ({
    // indices of selected slots
    selectedIndices: [] as number[],
  }),
  computed: {
    moment: () => moment,
  },
  methods: {
    formatEvent(ev: EventSelectionItem) {
      const from = moment(ev.from).format('DD.MM.YYYY, HH:mm [Uhr]');
      const to = moment(ev.to).format('HH:mm [Uhr]');
      return `${from} – ${to}`;
    },
    toggleEvent(idx: number) {
      const isOn = !this.selectedIndices.includes(idx);
      if (isOn) {
        if (this.item.multi) {
          this.selectedIndices.push(idx);
        } else {
          this.selectedIndices = [idx];
        }
      } else {
        this.selectedIndices = this.selectedIndices.filter(i => i !== idx);
      }
    },
    goNext() {
      const payload = {
        type: SurveyItemType.EVENT_SELECTION,
        events: this.selectedIndices.map(i => {
          const ev = this.item.events[i];
          return {
            from: moment(ev.from).toDate(),
            to: moment(ev.to).toDate(),
          };
        }),
      };
      this.$emit('responseItem', payload);
      this.$emit('update:step', this.step + 1);
    },
  },
});
</script>